<template>
  <a :href="url">
    <div class="card">
      <el-card :body-style="{ padding: '0px' }">
        <img
            :src="coverUrl"
            class="cover"

        />
        <div style="padding: 14px">
          <h2 class="title">{{title}}</h2>
          <span class="intro">{{intro}}</span>
        </div>
      </el-card>
    </div>
  </a>
</template>

<script>
export default {
  name: "go_book",
  data() {
    return {
      title: "Gopher必看的Go语言圣经，阅读笔记在这里",
      intro: "go语言圣经是每一位gopher在学习路上都应好好阅读的一本书",
      url: "posts/go_book.html",
      coverUrl: "img/go_cover_2.png"
    }
  }
}
</script>

<style scoped>
a {
  margin-top: 5%;
  display: block;
}

.card :hover {
  overflow: visible;
  transform: scale(1.1);
  transition: all 0.6s;
}
img{
  width: 100%;

}
.cover{
}
.title{
  color: #303133;
  font-size: small;

}
.intro{
  color: #909399;
  margin-left: 3%;
  font-size: smaller;

}
.el-card{
  height:300px;
  width: 250px;
}
</style>